import { memo, useRef, useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Popup from "../../popup"
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import { AMAskForQuotation, AMGetLookups } from '@/api/endpoints/AccountManager'
import { DomainContext } from '@/context/DomainContext'
import { errorToast, successToast } from '@/utils/toasters'
import { useGet } from '@/api/hooks'
import { Block } from '@/components/crRender'

const getId = (i) => i?.medicalOrderId || i?.orderId || i?.requestId || i?.id || i?.brokerPatientId

const HospitalPopup = ({  hospitalRef, providerIds, setProviderIds, selectedItems = []  }) => {
  const { ToggleReloadTable, setLoading } = useContext(DomainContext)
  const localRef = useRef()
  const activeRef = hospitalRef || localRef
  const [hospitals , setHospitals] = useState([])
  const [selectedHospitals, setSelectedHospitals] = useState(providerIds)
  const { t } = useTranslation()





  const handleApply = async () => {
    const ids = selectedItems.map(getId).filter(Boolean)
    if (!ids.length) return errorToast(t('error-validation'))

    const providersIds = selectedHospitals
      .map((h) => (h.value === 'all' ? null : Number(h.value)))
      .filter((v) => v !== null && !isNaN(v))

    if (!providersIds.length) return errorToast(t('select-at-least-one-hospital'))

    setLoading((l) => l + 1)
    try {
      const payload = {
        providersIds: providersIds,
        brokerPatientsIds: ids,
      }
      await AMAskForQuotation(payload)
      successToast(t('quotation-requested-success'))
      ToggleReloadTable((p) => !p)
      activeRef?.current?.click()
    } catch (err) {
      console.error(err)
      errorToast(t('quotation-requested-failed'))
    } finally {
      setLoading((l) => l - 1)
    }
  }

useEffect(()=>{
  AMGetLookups().then((res)=>{
    setHospitals(res.data)
    console.log(res.data)
  })
},[])

  return (
    <>
      <Popup needbtn={true} btnName="ask-for-quotation" onApply={handleApply} large={false} title={t("select-hospitals")} name={`hospital-select-popup`} modalID={activeRef}>
         <Block isRender={hospitals?.length}>
          <div className="hospital-filter">
          <MultiSelect
            label="global-hospital-filter"
            options={hospitals.map((h)=>({label:h.label,value:h.value}))}
            sOptions={selectedHospitals}
            setSOptions={setSelectedHospitals}
            className="w-100 hospital-filter-select"
            isMulti={true}
          />
        </div>
         </Block>
        </Popup>
    </>
  )
}

export default memo(HospitalPopup)